export default __webpack_public_path__ + "static/media/favorites-active.5af6e422.svg";